import ArtistMessages from '../../Artist/create-tooltips'

const messages = {
  classification: `<b>楽曲区分</b><br>
オリジナル: アーティスト本人が一から作詞や作曲した楽曲。<br>
原型の曲（俗に言う「原曲」）を指します。<br>
曲に含まれるコンテンツ（サンプル、ループ素材等を使用している場合）<br>
の権利に関しては、事前に許諾を得ている必要があります。<br><br>
カバー: オリジナルで作詞や作曲をしていない、過去に他人が発表した曲を<br>
新たに録音やパフォーマンスされた楽曲。リミックス、マッシュアップ、<br>
サンプルはカバーに該当しません。<br><br>
アレンジ: オリジナルで作詞や作曲をしていない、過去に録音された楽曲に<br>
メロディーの変更や歌詞の変更等が加えられた楽曲。<br>
編曲については、原曲の権利者に事前の許諾を得ている必要があります。<br><br>
パブリックドメイン: 著作権により保護されていた著作物が、<br>
著作権の保護期間を経過して社会の公共財産になり、<br>
だれでも自由に利用できるようになった楽曲。<br>
著作権の保護期間に関しては、文化庁やJASRACのホームページにてご確認ください。<br><br>カバー、アレンジ、パブリックドメインのいずれかを選択した場合は<br>YouTubeマネタイズサービスはご利用いただけません。`,
  title_ja: `<b>全角125文字以内 もしくは 半角英数字250文字以内</b><br>
    各配信ストアの規程により自動変換（オートキャップ）される場合があります。<br>
    例: MUSIC → Music<br>
    <br>使用不可ワード<br>
    例: オリジナルミックス / 配信限定 / デジタルシングル など<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。<br><br>
    タイトル欄にバージョン情報は入力しないでください。`,
  title_kana: `<b>全角カナ70文字以内</b><br>半角、全角スペースは使用できません。<br><br>
    使用不可ワード<br>
    例: オリジナルミックス / ハイシンゲンテイ / デジタルシングル など<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
   *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  title_en: `<b>半角英数字250文字以内</b><br>
    各配信ストアの規程により自動変換（オートキャップ）される場合があります。<br>
    例: MUSIC → Music<br>
    <br>
    アルファベット表記の例<br>
    タイトル:美しい日々<br> アルファベット表記:Utsukushiihibi<br>
    配信ストアによっては、海外ユーザー向けの表記となる場合がございます。<br>
    <br>使用不可ワード<br>
    例: Original Mix / Limited / Digital Single など<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  versions: `<b>バージョン</b><br>
バージョンはオリジナル楽曲と区別するために追加します。<br>入力されたバージョンは自動で楽曲タイトルへ追記されます。<br>
<br>
バージョンの使用例:<br>
2020 Ver.<br>
Remix<br>
Instrumental<br>
Radio Edit<br>
2016 リマスターバージョン<br>
2016 Remastered Version<br>
Acapella Ver.<br>
Cover<br>
Live at 武道館、東京、2018<br>`,
  version_ja: `<b>全角125文字以内 もしくは 半角英数字250文字以内</b><br>
    オリジナルと違ったバージョンの場合に入力してください。<br>
    例: Live from Tokyo, Club Remix, Radio Edit<br><br>
    使用不可ワード<br>
    例: オリジナルミックス / 配信限定 / デジタルシングル など<br>
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。<br><br>
    バージョン欄に入力した内容がタイトルの後ろに記載されます。`,
  version_kana: `<b>全角カナ70文字以内</b><br>半角、全角スペースは使用できません。
    <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。<br>`,
  version_en: `<b>半角英数字250文字以内</b><br><br>
    アルファベット表記の例<br>
    タイトル:Live from Tokyo<br> アルファベット表記:Live from Tokyo<br>
    配信ストアによっては、海外ユーザー向けの表記となる場合がございます。<br><br>
    使用不可ワード<br>
    例: Original Mix / Limited / Digital Single など<br>
   <br>
    以下は入力NGです。<br>
    ・絵文字などの特殊文字<br>
     *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  main_artist_name_ja: ArtistMessages.name_ja,
  main_artist_name_kana: ArtistMessages.name_kana,
  main_artist_name_en: ArtistMessages.name_en,
  featuring_artists: `<b>Featuringアーティスト</b><br>
    楽曲にフィーチャリングアーティストが存在する場合は入力します。<br>
    入力されたフィーチャリングアーティスト名は、配信ストアにより自動で楽曲タイトルへ追記される場合があります。<br>
    例: Story (feat. 山田 太郎)<br>
    例: Story (feat. Taro Yamada & Jiro Yamada)<br><br>
    以下は入力NGです。<br>
    ・Steven Tyler from Aerosmith[グループ名が含まれる]<br>
    ・Joe（Gt）[役割が含まれる]<br>
    ・山田 太郎 ＆ マイケル [複数名が含まれる]
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  featuring_artist_name_ja: ArtistMessages.name_ja,
  featuring_artist_name_kana: ArtistMessages.name_kana,
  featuring_artist_name_en: ArtistMessages.name_en,
  vocal: `<b>ボーカル入り</b><br>
    楽曲にボーカルが入っていない場合は&quot;いいえ&quot;を選択します。<br>`,
  freetrack: `<b>フリートラックの使用について</b><br>
    楽曲の中でフリートラックを使用している場合は<br>
   「YouTubeマネタイズサービス」を利用することはできません。<br>`,
  parental_warning: `<b>歌詞・タイトルの表現について</b><br>
    歌詞やタイトルに暴力的な単語・放送禁止用語・露骨な表現等が含まれる場合は、"はい"を選択します。<br>
    正しく選択されなかった場合、配信ストアにより、配信ができない・配信の停止が行われる場合があります。`,
  languages: `<b>歌唱言語</b><br>
    歌詞に最も使用されている言語。<br><br>
    日本語と英語の両方を使われている場合、どちらか多く使われている言語を選択します。<br>
    誤った言語が選択されていると判断された場合、配信ストア側にて修正あるいは配信停止される可能性があります。`,
  copyright_group: `<b>著作権管理団体</b><br>
    既に著作権を登録している場合はJASRAC/NexToneを選択し、著作権登録をしていない場合はその他を選択してください。`,
  copyright_artists: `<b>著作者</b><br>
    楽曲を作製した作詞・作曲・編曲者名を入力します。<br><br>
    著作権管理事業者に委託されている場合は、申請されている通りの著作権者名を入力してください。<br>
    正しく入力されなかった場合、正常に管理事業者で処理されない場合があります。`,
  copyright_artist_name_ja: `<b>全角・半角英数字</b><br>
    著作者名（実名、グループ名、アーティスト名等）を入力します。<br>
    正しい例: 山田 太郎<br>
    正しい例: Michael Jackson<br><br>
    以下は入力NGです。<br>
    ・山田 太郎 ＆ マイケル [複数名が含まれる]<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  copyright_artist_name_en: `<b>半角英数字</b><br>
    著作者名（実名、グループ名、アーティスト名等）を入力します。<br>
    正しい例: Taro Yamada<br>
    正しい例: Michael Jackson<br>
    <br>
    アルファベット表記の例<br>
    タイトル:山田 太郎<br>
    アルファベット表記:Taro Yamada<br>
    配信ストアによっては、海外ユーザー向けの表記となる場合がございます。<br><br>
    以下は入力NGです。<br>
    ・Taro Yamada & Michael [複数名が含まれる]<br>
    ・絵文字などの特殊文字<br>
    *限定的であったり、購入者の混乱を招く表現を含めることはできません。`,
  isrc: `<b>ISRC</b><br>
    <b>半角英数字</b><br>
    英数字12桁で入力します。<br>
    正しい例: JPW012345678<br><br>
    ISRCコードとは「International Standard Recording Code」の略称で、<br>
    日本語で「国際標準レコーディングコード」といいます。<br>
    楽曲情報を管理する為に、各国のレコード協会から発行されるコード番号です。<br>
    <a href="/client/faqs/24" target="_blank">ISRCコードは必要ですか？</a>`,
  isrc_tob: `<b>ISRC</b><br>
    ISRCコードとは「International Standard Recording Code」の略称で、<br>
    日本語で「国際標準レコーディングコード」といいます。<br>
    楽曲情報を管理する為に、各国のレコード協会から発行されるコード番号です。<br>
    <a href="/client/faqs/39" target="_blank">ISRCコードは必要ですか？`,
  remarks_ja: `<b>全角・半角英数字</b><br>
    アルバムの説明・PR・タイアップ情報などを入力します。<br>
    当サービス及び一部の配信ストアで利用させて頂く場合があります。<br><br>
    *上限1000文字`,
  remarks_en: `<b>全角・半角英数字</b><br>
    アルバムの説明・PR・タイアップ情報などを入力します。<br>
    当サービス及び一部の配信ストアで利用させて頂く場合があります。<br><br>
    *上限1000文字`,
  listening_position: `TikTokへの配信時は、視聴開始位置から60秒間が配信されます。<br>
    ストアの設定により試聴開始位置は変更となる場合がございます。
    <br><br>
    各ストアの試聴時間は<a href="/client/static/store-detail" target="_blank">こちら</a>。`,
  use_copyright_free: '楽曲の中で著作権フリー楽曲を使用している場合は「YouTubeマネタイズサービス」を利用することはできません。',
  has_sold_copyright_free: '著作権フリー楽曲として販売をしていた実績がある場合は「YouTubeマネタイズサービス」を利用することはできません。',
  rightsdocument: `▼許諾を証明できる添付データの例<br>
・許諾証明書の画面キャプチャ<br>
・権利者とやりとりをしたテキスト内容の画面キャプチャ<br>
・素材提供元の利用規約のURL（商用利用可であることが明記されている必要あり）`,
}
messages.versions_b2b = `${messages.versions}<br><a href="/client/faqs/153" target="_blank">【アルバム・トラックのタイトルにバージョン名を登録したい】</a>`
messages.versions_b2c = `${messages.versions}<br><a href="/client/faqs/152" target="_blank">【アルバム・トラックのタイトルにバージョン名を登録したい】</a>`
export default messages
